// Miroir des rôles des agents (espoar-api/models/UserManager.js → ROLES),
// même approche que helpers/orientationTypes.js : la constante ROLES_MANAGER
// n'est pas toujours servie par constants/BOA (absente en local), le menu
// compte a pourtant besoin d'un libellé de rôle. Les constantes, quand elles
// existent, priment (voir MenuLateral.libelleDuRole).
// Les trois derniers rôles sont ceux des comptes d'opérateur d'accompagnement
// (CE-1407) : un tel compte n'a ni organisation ni site, seulement sa
// structure (`operateur` dans le jeton de session).
const ROLES_MANAGER = [
  { id: "SUPER_ADMIN", name: "Super Administrateur" },
  { id: "ADMIN", name: "Administrateur" },
  { id: "CAF_DIRECTOR", name: "Directeur de la CAF" },
  { id: "MANAGER", name: "Manageur CAF" },
  { id: "AGENT_CAF_TS", name: "Agent CAF TS" },
  { id: "AGENT_CAF_EG", name: "Agent CAF EG" },
  { id: "AGENT_CSU_CDD", name: "Agent CSU-CDD" },
  { id: "MANAGER_PARTNER", name: "Manageur PARTENAIRE" },
  { id: "AGENT_PARTNER", name: "Agent PARTENAIRE" },
  { id: "ADMIN_OPERATEUR", name: "Administrateur d'opérateur" },
  { id: "MANAGEUR_OPERATEUR", name: "Manageur d'opérateur" },
  { id: "AGENT_OPERATEUR", name: "Agent d'opérateur" },
];

export const ROLES_OPERATEUR = ["ADMIN_OPERATEUR", "MANAGEUR_OPERATEUR", "AGENT_OPERATEUR"];

export const estRoleOperateur = (role) => ROLES_OPERATEUR.includes(role);

export const estAdministrateurOperateur = (role) => role === "ADMIN_OPERATEUR";

// Le rôle seul fait le compte d'opérateur : un compte sans structure est une
// incohérence de données, pas un agent Caf.
export const estUtilisateurOperateur = (user) => Boolean(user) && estRoleOperateur(user.role);

export default ROLES_MANAGER;
